// Rollup (collapse/expand) for Operations sections — George 2026-08-11:
// "need to have a rollup option for all tabs". Clicking a section title rolls
// the section up to just its header; sibling controls in the same header row
// (filters, upload buttons, year pickers) are NOT part of the click target so
// they keep working untouched. Collapsed state persists per-section in
// localStorage, so the layout survives reloads. Default is EXPANDED — nothing
// is hidden until the user rolls it up themselves (standing rule: no hidden
// UI by default).
import { useState } from 'react';
import { styles } from './UI';

const STORE_KEY = 'sss_crm_ops_rollup';

function readStore() {
  try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {}; }
  catch { return {}; }
}

// [collapsed, toggle] for one section id. Ids are namespaced per tab
// ('roster', 'jobnums-register', 'gantt-demand', ...) — keep them stable or
// the user's saved layout silently resets.
export function useRollup(id) {
  const [collapsed, setCollapsed] = useState(() => !!readStore()[id]);
  const toggle = () => setCollapsed(prev => {
    const next = !prev;
    try {
      const map = readStore();
      if (next) map[id] = 1; else delete map[id];
      localStorage.setItem(STORE_KEY, JSON.stringify(map));
    } catch { /* storage unavailable — session-only collapse still works */ }
    return next;
  });
  return [collapsed, toggle];
}

// Clickable section heading with the rollup chevron. Renders an h2 by
// default (pass as="h3" for sub-section headings). Only the heading itself
// toggles.
export function RollupH2({ collapsed, onToggle, children, style, as = 'h2' }) {
  const Tag = as;
  // Base keeps styles.h2's own margin ('0 0 12px 0'); callers that sit inside
  // a header row pass style={{ margin: 0 }} exactly as their old h2 did.
  const base = as === 'h2' ? { ...styles.h2 } : { fontSize: 14, fontWeight: 700, margin: 0 };
  return (
    <Tag
      onClick={onToggle}
      title={collapsed ? 'Expand section' : 'Roll up section'}
      style={{ ...base, cursor: 'pointer', userSelect: 'none', ...style }}
    >
      <span aria-hidden="true" style={{ display: 'inline-block', width: 16, fontSize: 10, color: '#9CA3AF', verticalAlign: 'middle' }}>
        {collapsed ? '▶' : '▼'}
      </span>
      {children}
    </Tag>
  );
}
